import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { ApplicationModel } from './application'
import { ComboApplication } from './comboapplication'
import { Application } from './appl';
import { HttpManagerService } from '../../api/httpmanager.service';

import { MasterDataConstant } from '../../api/masterdata.constant';

@Injectable()
export class ApplicationService {
    constructor(
        private masterdataservice: MasterDataConstant,
        private httpmanagerService: HttpManagerService
    ) {
    }
    allApplication(isactive): Promise<ApplicationModel[]> {
        return this.httpmanagerService.HttpGet('sapplication', isactive).then(data => {
            return data.data;
        })
    }
    ComboApplication(): Promise<ComboApplication[]> {
        if(this.masterdataservice.ApplicationList == undefined)
        {
            this.masterdataservice.ApplicationList = [];
        }
        if(this.masterdataservice.ApplicationList.length == 0)
        {
            var isactive = -1;
            return this.httpmanagerService.HttpGet('sapplication', isactive).then(data => {
                this.masterdataservice.ApplicationList = data.data;
                return data.data;
            })
        }
        else
        {
            return new Promise( resolve => {
                resolve(this.masterdataservice.ApplicationList);
              } );
        }
    }
    addApplication(application): Promise<Application> {
        return this.httpmanagerService.HttpPost('sapplication', JSON.stringify(application), "").then(data => {
            return data;
        })
    }
    deleteApplication(id) {
        return this.httpmanagerService.HttpDelete('sapplication', id).then(data => {
            return data;
        })
    }
    updateApplication(id, application) {

        return this.httpmanagerService.HttpPut('sapplication', JSON.stringify(application), id).then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/application/application.service.ts